/**
 * @module: 商机
 * @author: Teacher Tang
 * @date: 2020-06-03 10:40:16
 */

import { observable, action, flow, toJS, computed } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import { withRole } from '@src/utils/residentNew';
import { Job } from '@src/entity/resident/job';
import { IMenuData } from '@src/entity/user';
import axios from 'axios';
import { PositionFilterOption } from '@src/utils/constant';
import { ISelection } from '@src/entity/resident/offer';
interface IAds {
  id: number;
  attachment: number;
  title: string;
  path: string;
  link: string;
  platform: number;
  kind: string;
  hover_path: string;
  visible: boolean;
  init_role: number;
}

interface IOfferParams {
  offer_uuid?: string; //	职位uuid
  company?: number; //	公司ID
  offer_prop?: number; //	工作类型（1云工作,2自招,3驻场)
  min_salary?: number; //	职位的下限薪资
  max_salary?: number; //	职位的上限薪资
  remote?: number; //	是否支持远程面试
  renewal?: number; //	是否续签
  degree?: number; //	职位要求的学历
  exper?: number; //	职位要求的工作年限
  relate_date?: number; //	发布时间筛选
  job_intention?: number; //	职位要求的技术方向
  location?: number; //	职位的工地地点
  keyword?: string; //	搜索关键字
  period?: number; //	驻场周期筛选
  is_urgent?: number; //	是否加急(1加急,2普通)
  sort?: string; //	排序规则(desc降序,asc升序)
  order_by?: string; //	排序字段
  refresh_at?: string; //	order_by对应的参数(刷新时间排序)
  assist_count?: string; //	order_by对应的参数(助力值排序)
  create_at?: string; //	order_by对应的参数(创建时间排序)
  job_type?: string; //	自定义排序(hot浏览数排序,high高薪排序)
}

export const PAGE_SIZE = 20;

const SEARCH_HISTORY = 'business-search-history';

const DEFAULT_LOCAL = {
  value: -2,
  label: '全国',
  children: [
    {
      value: -1,
      label: '全国'
    }
  ]
};

const DEFAULT_MENU = [-2, -1];

class Business {
  // 用于cancel ajax请求
  @observable source;
  @observable menuInfo: any[] = DEFAULT_MENU;
  // 轮播图
  @observable ads: IAds[] = [];
  // 热门搜索列表
  @observable historyList: any[] = [];
  // 热门职位
  @observable
  hotList: any[] = [
    'Java',
    'C++',
    'web前端',
    'iOS',
    'Android',
    '产品经理',
    'UI设计师',
    '产品运营'
  ];
  // 职位数据
  @observable
  offers: Job[] = [];
  // 职位列表请求
  @observable fetching: string = 'init';
  // 数据总条数
  @observable total: number = 0;
  // 选项 第几页
  @observable pagenum: number = 1;
  // 选择的tab
  @observable tabIndex: number = 0;
  // 筛选条件选择项
  @observable selection: ISelection = {};

  /**
   * 当前选中地址
   */
  @observable local: IMenuData | undefined = DEFAULT_LOCAL;
  /**
   * 搜索关键字
   */
  @observable keyword: string = '';
  /**
   * 是否悬赏
   * 默认悬赏
   */
  @observable award: string | number = 1;
  /**
   * 是否加急
   */
  @observable is_urgent: string | number = '';
  /**
   * 离开首页后记录筛选内容
   */
  @observable entBusiness: any;
  /**
   * 离开搜索页后记录筛选内容
   */
  @observable searchBusiness: any;
  /**
   * 展示搜索结果
   */
  @observable showResult: boolean = false;
  /**
   * 筛选条件记录
   */
  @observable tempSelectionStr: string = '';
  /**
   * 筛选条件
   *
   * @readonly
   * @type {IOfferParams}
   * @memberof Offer
   */
  @computed
  get params(): IOfferParams {
    let params: any = {};
    Object.keys(toJS(this.selection)).forEach((key: string) => {
      const r = this.selection[key];
      if (r) {
        if (key === PositionFilterOption.ExpectedSalary) {
          params.min_salary = r.min_salary;
          params.max_salary = r.max_salary;
        } else {
          params[key] = r.id;
        }
      }
    });
    return params;
  }

  constructor() {
    try {
      const h = localStorage.getItem(SEARCH_HISTORY);
      console.log('h', h)
      if (h) {
        this.historyList = [...new Set(JSON.parse(h))].reverse();
      }
    } catch (error) { 
      console.log('h error', error)
    }
  }

  // 广告数据
  @action.bound
  getAds = flow(function* (this: Business) {
    try {
      const res = yield ajax.getJson(
        '/company/api/banners',
        { kind: 'app-business' }
      ) as any;
      if (+res.error_code === 0) {
        this.ads = res.result as IAds[];
      }
    } catch (error) { }
  });

  /**
   * 获取职位列表
   *
   * @memberof Offer
   */
  @action.bound
  getOffers = flow(function* (this: Business) {
    // 记录
    const tempStatus = this.fetching;
    if (this.fetching !== 'loadingMore' && this.fetching !== 'refreshing') {
      this.fetching = 'pending';
    }
    // 阻止上一个请求
    if (this.source) {
      this.source.cancel();
    }
    this.source = axios.CancelToken.source();

    const offer_prop = '1,2';
    console.log('pagenum', this.pagenum, 'params', this.params);
    const params = {
      offer_prop,
      ...this.params,
      pagesize: PAGE_SIZE,
      pagenum: this.pagenum,
      is_urgent: this.is_urgent,
      award: this.award,
      location: this.local && this.local.value > 0 ? this.local.value : '',
      keyword: this.keyword || ''
    };

    try {
      const res = yield axios
        .get(`/mresident/api/offers?ts=${Date.now()}`, {
          params: withRole(params, 1),
          cancelToken: this.source.token
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            this.fetching = 'cancel';
          }
        });
      // 记录当前筛选的条件
      this.tempSelectionStr = this.paramsStr;
      if (res && res.data && +res.data.error_code === 0) {
        this.fetching = 'done';
        if (
          (this.pagenum > 1 && tempStatus === 'refreshing') ||
          tempStatus === 'loadingMore'
        ) {
          this.offers = this.offers.concat(
            res.data.offers
          ) as Job[];
        } else {
          this.offers = res.data.offers as Job[];
        }
        this.total = res.data.total;
      } else {
        this.fetching = 'error';
      }
    } catch (error) {
      this.fetching = 'error';
    }
  });

  @computed
  get paramsStr(): string {
    return JSON.stringify(this.params);
  }

  @action.bound
  getHot = flow(function* (this: Business) {
    try {
      const res = yield ajax.getJson(
        '/mresident/api/hot-offer-tag',
        withRole({}, 2)
      ) as any;
      this.hotList = res.result;
    } catch (error) {
      return error;
    }
  });

  /**
   * 保存筛选条件 关键字 选择的tab
   */
  @action.bound
  saveSelectionTo(key: string) {
    this[key] = {
      selection: toJS(this.selection),
      keyword: toJS(this.keyword),
      award: toJS(this.award),
      is_urgent: toJS(this.is_urgent),
      tabIndex: toJS(this.tabIndex),
      local: toJS(this.local),
      menuInfo: toJS(this.menuInfo)
    };
  }

  /**
   * 获取保存的筛选条件 关键字 选择的tab
   */
  @action.bound
  getSelectionFrom(key: string) {
    return this[key];
  }

  /**
   * 装载数据：筛选条件 关键字 选择的tab
   * @param target
   */
  @action.bound
  mountSelection(target: any) {
    if (!target) return;
    const { selection, tabIndex, keyword, local, menuInfo } = target;
    if (typeof keyword === 'string') this.keyword = keyword;
    if (typeof tabIndex === 'number') this.tabIndex = tabIndex;
    if (selection) this.selection = selection;
    this.local = local;
    this.menuInfo = menuInfo;
  }

  /**
   * 页面切换时重置筛选
   */
  @action.bound
  reset() {
    this.keyword = '';
    this.selection = {};
    this.tabIndex = 0;
    this.award = 1;
    this.is_urgent = '';
    this.pagenum = 1;
    this.total = 0;
    this.local = DEFAULT_LOCAL;
    this.menuInfo = DEFAULT_MENU;
  }

  /**
   * 添加搜索历史
   * @param name 搜索字符
   */
  @action.bound
  pushHistory(name: string) {
    this.historyList.unshift(name);
    // 去重
    this.historyList = [...new Set(this.historyList)];
    // 截取前10
    if (this.historyList.length > 10) {
      this.historyList = this.historyList.slice(0, 10);
    }
    localStorage.setItem(
      SEARCH_HISTORY,
      JSON.stringify(toJS(this.historyList))
    );
  }

  /**
   * 清空搜索历史
   */
  @action.bound
  removeAll() {
    this.historyList = [];
    localStorage.setItem(SEARCH_HISTORY, '');
  }
}

export default Business;
